import { Injectable } from '@angular/core';
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { AngularFirestore } from '@angular/fire/firestore';
import * as AWS from 'aws-sdk';
import { AuthService } from './auth.service';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { Platform } from '@angular/cdk/platform';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({ providedIn: "root" })
export class PushMsgService {
  constructor(private firebaseX: FirebaseX, private push: Push,
    private platfrom: Platform, private firebase: AngularFireAuth,
    public firestore: AngularFirestore, public auth: AuthService) { }

  async getToken() {
    if (this.platfrom.IOS) {
      const options: PushOptions = {
        ios: {
          alert: 'true',
          badge: true,
          sound: 'false'
        }
      }
      this.push.hasPermission()
        .then((res: any) => {
          if (res.isEnabled) {
            const pushObject: PushObject = this.push.init(options);
            pushObject.on('registration').subscribe((registration: any) => (
              this.sns(registration.registrationId)
            ));
          } else {
            console.log('We do not have permission to send push notifications');
          }
        });
    }
    if (this.platfrom.ANDROID) {
      let token = await this.firebaseX.getToken();
      await this.firebaseX.grantPermission();
      this.sns(token)
    }
  }

  sns(id) {
    let TopicArn;
    const data = { id, app: 'yessboss', userId: localStorage.getItem('currentUserId') };
    var sns = new AWS.SNS({
      apiVersion: '2010-03-31',
      region: 'us-east-1',
      accessKeyId: 'AKIAIYQEUXDQ7P4T4CVA',
      secretAccessKey: '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'
    });

    if (this.platfrom.IOS)
      TopicArn = "arn:aws:sns:us-east-1:324294240674:app/APNS/yessboss_ios";
    else
      TopicArn = 'arn:aws:sns:us-east-1:324294240674:app/GCM/yessboss';
    var params = {
      PlatformApplicationArn: TopicArn,
      Token: data.id,
      CustomUserData: data.userId
    };

    sns.createPlatformEndpoint(params, (err, data) => {
      if (err) {         this.postArn(data.EndpointArn)
        this.setTopics(sns, data.EndpointArn) } // an error occurred
      else {// successful response
        this.postArn(data.EndpointArn)
        this.setTopics(sns, data.EndpointArn)
      }
    });
  }

  setTopics(sns, data) {
    var params = {
      Protocol: 'application',
      TopicArn: 'arn:aws:sns:us-east-1:324294240674:app/GCM/yessboss',
      Endpoint: data
    };
    sns.subscribe(params, (err, data2) => {
      if (err) { return null } // an error occurred
      else {
        var params2 = {
          AttributeName: 'FilterPolicy', /* required */
          SubscriptionArn: data2.SubscriptionArn, /* required */
          AttributeValue: "{\"user_data\": [\"" + localStorage.getItem('currentUserId') + "\"],\"user_sub\": [\"" + 'all' + "\"]}"
        }
        sns.setSubscriptionAttributes(params2, function (err, data) {
          if (err) { return null } // an error occurred
          else {
          } // successful response
        });
      } // successful response
    });
  }

  postArn(arn) {
    this.auth.getCapabilityArn(localStorage.getItem('currentUserId'), arn).subscribe(res => {

    })
  }

}